module.exports = __webpack_public_path__ + "img/logo.b4a009a0.png";